import React from 'react'
import ContractsView from './ContractsListView'
import * as contractsService from '../ContractsService'
import * as FlashMessage from '../../FlashMessage/FlashMessageConstants'

export default class Contracts extends React.Component {

    componentDidUpdate(prevProps) {
        if (!prevProps.apiClientLoaded && this.props.apiClientLoaded) {
            this.listContracts()
        }
    }

    componentDidMount() {
        const { createdContract, apiClientLoaded, contracts, newCurrentContract, setPath } = this.props
        setPath(this.props.match.path)
        const refreshContractListRequired = contracts.length === 0 || createdContract || newCurrentContract
        if (apiClientLoaded && refreshContractListRequired) {
            this.refreshContractsList()
        }
    }

    refreshContractsList() {
        const { setContractsLoadedRequest, newContract, currentContractUpdated } = this.props
        currentContractUpdated(false)
        setContractsLoadedRequest(false)
        newContract(false)
        this.listContracts()
    }

    render() {
        return <ContractsView
            contractsLoadDone={this.props.contractsLoaded}
            contracts={this.props.contracts}
        />
    }

    listContracts() {
        const { setContracts, setContractsLoadedRequest, setFlashMessage } = this.props
        contractsService.getContracts()
            .then(contracts => {
                setContracts(contracts)
            })
            .catch(() => {
                setFlashMessage(FlashMessage.ListContractsFailed)
            })
            .finally(() => {
                setContractsLoadedRequest(true)
            })
    }
}


// WEBPACK FOOTER //
// ./src/components/Contracts/List/ContractsList.jsx